import { gql } from 'apollo-boost';

export const GET = gql`
{
  sites {
    id
    name
    domain
    publisherId
    services{
      enabled
      name
    }
    initial
    percentual
  }
}
`;

export const ADD = gql`
  mutation createSite($domain: String!, $initial: String!, $name: String!, $services: [ServiceInput!]!, $percentual: Float!) {
    createSite(input: { domain: $domain, initial: $initial, name: $name, services: $services, percentual: $percentual}) {
      id
      name
      domain
      initial
      publisherId
      services{
        enabled
        name
      }
      percentual
    }
  }
`;

export const EDIT = gql`
  mutation updateSite($id: String!, $initial: String!, $domain: String!, $name: String!, $services: [ServiceInput!]!, $percentual: Float!) {
    updateSite(id: $id, input: { domain: $domain, initial: $initial, name: $name,services: $services, percentual:$percentual }) {
      id
      name
      domain
      initial
      publisherId
      services{
        enabled
        name
      }
      percentual
    }
  }
`;

export const DELETE = gql`
mutation deleteSite($id: String!) {
  deleteSite(id: $id) {
    id
  }
}
`;
